import {
  GROOVING_TYPE_CODE_ASYMMETRICAL_GROOVING,
  GROOVING_TYPE_CODE_SYMMETRICAL_GROOVING,
  GROOVING_TYPE_CODE_WITHOUT_GROOVING,
} from "../../../http/deckDesigner/types/groovingTypes";

// Fixed structural minimums per grooving type (mm), independent of the selected connector family.
export const MIN_BOARD_THICKNESS_BY_GROOVING_TYPE_MM: Record<string, number> = {
  [GROOVING_TYPE_CODE_SYMMETRICAL_GROOVING]: 10,
  [GROOVING_TYPE_CODE_ASYMMETRICAL_GROOVING]: 6,
  [GROOVING_TYPE_CODE_WITHOUT_GROOVING]: 10,
};

// Minimum material required above an asymmetrical groove (mm) - shared by BoardsCard's board
// thickness validation, ConnectorsCard's family-fit filter and DeckDesigner, so they can't drift.
export const ASYMMETRICAL_GROOVING_MARGIN_MM = 3;

// Conservative stand-in for the family's own groovingThickness when no family is selected yet, so
// the board thickness field can still enforce a real (if provisional) minimum instead of none at all.
export const ASYMMETRICAL_GROOVING_FALLBACK_MARGIN_MM = 6;

// Minimum board thickness for an asymmetrical groove: the family's grooving thickness + the grooving
// height + the margin above it, or the fallback margin while no family (so no grooving thickness) is
// known. The one formula BoardsCard's validation, ConnectorsCard's family filter and DeckDesigner use,
// mirrored by the server (configuration_handler.go).
export const getAsymmetricalGroovingMinimumBoardThickness = (
  groovingHeight: number,
  familyGroovingThickness: number | null | undefined,
): number =>
  familyGroovingThickness != null
    ? familyGroovingThickness + groovingHeight + ASYMMETRICAL_GROOVING_MARGIN_MM
    : groovingHeight + ASYMMETRICAL_GROOVING_FALLBACK_MARGIN_MM;
